export default {
  success (state) {
    return state.success
  },
  error (state) {
    return state.error
  },
  load (state) {
    return state.load
  }
}
